import { cn } from "@/lib/utils";

interface SubHeadingProps {
  children: React.ReactNode;
  className?: string;
}

export function SubHeading({ children, className }: SubHeadingProps) {
  return (
    <p className={cn("text-base text-muted-foreground font-normal", className)}>
      {children}
    </p>
  );
}
